var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',[_c('v-autocomplete',{attrs:{"label":_vm.label,"items":_vm.formasPagamentoNotConvenio,"item-text":"descricao","return-object":"","multiple":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }